/* TOMA PREÇO · PLP: ordenação e filtros com envio imediato no desktop (GET nativo; sem JS o botão "Ver produtos" envia) */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 990px)');
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-tp-sort]');
    if (sort) {
      var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      location.href = u.toString(); return;
    }
    var form = e.target.closest('[data-tp-filters]');
    if (form && desktop.matches && form.closest('.tp-plp__side') && e.target.type === 'checkbox') form.submit();
  });
  // campos de preço: Shopify espera valores em reais (aceita inteiro); remove vazios para não poluir a URL
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tp-filters]'); if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) { if (i.value === '') i.disabled = true; });
  });
})();
